















import AbpBase from "@/lib/abpbase"
import {Component} from "vue-property-decorator"
import Age from './parts/age.vue'
import Sex from './parts/sex.vue'
@Component({
	components:{Age, Sex}
})
export default class PatientStatistics extends AbpBase{
	position = 0
	buttons = ['患者年龄段统计','患者性别统计']
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/report/patientStatistics/index.vue